import { handleValidationChange } from "../CommonValidations/CommonValidaions";

export const validateHospitalization = (data, setError) => {
  var isValid = true;

  if (data.name === "") {
    handleValidationChange("name", true, setError);
    isValid = false;
  } else {
    handleValidationChange("name", false, setError);
  }

  if (data.admitted_on === "") {
    handleValidationChange("admitted_on", true, setError);
    isValid = false;
  } else {
    handleValidationChange("admitted_on", false, setError);
  }
  if (data.reason === "") {
    handleValidationChange("reason", true, setError);
    isValid = false;
  } else {
    handleValidationChange("reason", false, setError);
  }

  return isValid;
};

export const validateAllergy = (data, setError) => {
  var isValid = true;

  if (data.name === "") {
    handleValidationChange("name", true, setError);
    isValid = false;
  } else {
    handleValidationChange("name", false, setError);
  }

  if (data.type === "") {
    handleValidationChange("type", true, setError);
    isValid = false;
  } else {
    handleValidationChange("type", false, setError);
  }

  return isValid;
};

export const validateAsthma = (data, setError) => {
  /** Required:
   * username
   * password
   */

  var isValid = true;

  if (data.duration === "") {
    handleValidationChange("duration", true, setError);
    isValid = false;
  } else {
    handleValidationChange("duration", false, setError);
  }

  if (data.last_attack === "") {
    handleValidationChange("last_attack", true, setError);
    isValid = false;
  } else {
    handleValidationChange("last_attack", false, setError);
  }

  return isValid;
};

export const validateDiabetes = (data, setError) => {
  var isValid = true;

  if (data.duration === "") {
    handleValidationChange("duration", true, setError);
    isValid = false;
  } else {
    handleValidationChange("duration", false, setError);
  }

  if (data.usual_fbs === "") {
    handleValidationChange("usual_fbs", true, setError);
    isValid = false;
  } else {
    handleValidationChange("usual_fbs", false, setError);
  }

  if (data.usual_rbs === "") {
    handleValidationChange("usual_rbs", true, setError);
    isValid = false;
  } else {
    handleValidationChange("usual_rbs", false, setError);
  }

  if (data.hba1c === "") {
    handleValidationChange("hba1c", true, setError);
    isValid = false;
  } else {
    handleValidationChange("hba1c", false, setError);
  }

  if (data.cbg_range === "") {
    handleValidationChange("cbg_range", true, setError);
    isValid = false;
  } else {
    handleValidationChange("cbg_range", false, setError);
  }

  if (data.complications === "") {
    handleValidationChange("complications", true, setError);
    isValid = false;
  } else {
    handleValidationChange("complications", false, setError);
  }

  return isValid;
};

export const validateMedication = (data, setError) => {
  var isValid = true;

  if (data.generic === "") {
    handleValidationChange("generic", true, setError);
    isValid = false;
  } else {
    handleValidationChange("generic", false, setError);
  }

  if (data.brand === "") {
    handleValidationChange("brand", true, setError);
    isValid = false;
  } else {
    handleValidationChange("brand", false, setError);
  }

  // if (data.duration === "") {
  //   handleValidationChange("duration", true, setError);
  //   isValid = false;
  // } else {
  //   handleValidationChange("duration", false, setError);
  // }

  // if (data.preparation === "") {
  //   handleValidationChange("preparation", true, setError);
  //   isValid = false;
  // } else {
  //   handleValidationChange("preparation", false, setError);
  // }

  // if (data.form === "") {
  //   handleValidationChange("form", true, setError);
  //   isValid = false;
  // } else {
  //   handleValidationChange("form", false, setError);
  // }

  // if (data.dosage === "") {
  //   handleValidationChange("dosage", true, setError);
  //   isValid = false;
  // } else {
  //   handleValidationChange("dosage", false, setError);
  // }

  // if (data.timing === "") {
  //   handleValidationChange("timing", true, setError);
  //   isValid = false;
  // } else {
  //   handleValidationChange("timing", false, setError);
  // }
  // if (data.compliance === "") {
  //   handleValidationChange("compliance", true, setError);
  //   isValid = false;
  // } else {
  //   handleValidationChange("compliance", false, setError);
  // }
  // if (data.frequency === "") {
  //   handleValidationChange("frequency", true, setError);
  //   isValid = false;
  // } else {
  //   handleValidationChange("frequency", false, setError);
  // }

  return isValid;
};

export const validateHypertension = (data, setError) => {
  /** Required:
   * username
   * password
   */

  var isValid = true;

  if (data.duration === "") {
    handleValidationChange("duration", true, setError);
    isValid = false;
  } else {
    handleValidationChange("duration", false, setError);
  }

  if (data.highest_bp === "") {
    handleValidationChange("highest_bp", true, setError);
    isValid = false;
  } else {
    handleValidationChange("highest_bp", false, setError);
  }

  if (data.usual_bp === "") {
    handleValidationChange("usual_bp", true, setError);
    isValid = false;
  } else {
    handleValidationChange("usual_bp", false, setError);
  }

  return isValid;
};

export const validateHerbal = (data, setError) => {
  /** Required:
   * is_herbal_user
   * name / last_intake / duration when is_herbal_user === "Y"
   */

  var isValid = true;

  if (!data.is_herbal_user) {
    handleValidationChange("is_herbal_user", true, setError);
    isValid = false;
  } else {
    handleValidationChange("is_herbal_user", false, setError);
  }

  if (data.is_herbal_user === "Y") {
    if (data.duration === "" || data.duration == null) {
      handleValidationChange("duration", true, setError);
      isValid = false;
    } else {
      handleValidationChange("duration", false, setError);
    }

    if (data.name === "" || data.name == null) {
      handleValidationChange("name", true, setError);
      isValid = false;
    } else {
      handleValidationChange("name", false, setError);
    }

    if (data.last_intake === "" || data.last_intake == null) {
      handleValidationChange("last_intake", true, setError);
      isValid = false;
    } else {
      handleValidationChange("last_intake", false, setError);
    }
  } else {
    handleValidationChange("duration", false, setError);
    handleValidationChange("name", false, setError);
    handleValidationChange("last_intake", false, setError);
  }

  return isValid;
};

export const validateThyroid = (data, setError) => {
  var isValid = true;

  if (data.duration === "") {
    handleValidationChange("duration", true, setError);
    isValid = false;
  } else {
    handleValidationChange("duration", false, setError);
  }

  if (data.type === "") {
    handleValidationChange("type", true, setError);
    isValid = false;
  } else {
    handleValidationChange("type", false, setError);
  }

  if (data.medication === "") {
    handleValidationChange("medication", true, setError);
    isValid = false;
  } else {
    handleValidationChange("medication", false, setError);
  }

  if (data.rai === "") {
    handleValidationChange("rai", true, setError);
    isValid = false;
  } else {
    handleValidationChange("rai", false, setError);
  }

  if (data.surgery === "") {
    handleValidationChange("surgery", true, setError);
    isValid = false;
  } else {
    handleValidationChange("surgery", false, setError);
  }

  if (data.levothyroxine === "") {
    handleValidationChange("levothyroxine", true, setError);
    isValid = false;
  } else {
    handleValidationChange("levothyroxine", false, setError);
  }

  if (data.histopathologic === "") {
    handleValidationChange("histopathologic", true, setError);
    isValid = false;
  } else {
    handleValidationChange("histopathologic", false, setError);
  }

  return isValid;
};

export const validatePituitary = (data, setError) => {
  /** Required:
   * username
   * password
   */

  var isValid = true;

  if (data.name === "") {
    handleValidationChange("name", true, setError);
    isValid = false;
  } else {
    handleValidationChange("name", false, setError);
  }

  return isValid;
};

export const validateEndocrine = (data, setError) => {
  /** Required:
   * username
   * password
   */

  var isValid = true;

  if (data.name === "") {
    handleValidationChange("name", true, setError);
    isValid = false;
  } else {
    handleValidationChange("name", false, setError);
  }

  return isValid;
};

export const validateIllness = (data, setError) => {
  /** Required:
   * username
   * password
   */

  var isValid = true;

  if (data.name === "") {
    handleValidationChange("name", true, setError);
    isValid = false;
  } else {
    handleValidationChange("name", false, setError);
  }

  return isValid;
};

export const validateSmoking = (data, setError) => {
  /** Required:
   * is_smoker
   * duration / sticks_per_day when is_smoker === "Y"
   */

  var isValid = true;

  if (!data.is_smoker) {
    handleValidationChange("is_smoker", true, setError);
    isValid = false;
  } else {
    handleValidationChange("is_smoker", false, setError);
  }

  if (data.is_smoker === "Y") {
    if (data.duration === "" || data.duration == null) {
      handleValidationChange("duration", true, setError);
      isValid = false;
    } else {
      handleValidationChange("duration", false, setError);
    }

    if (data.sticks_per_day === "" || data.sticks_per_day == null) {
      handleValidationChange("sticks_per_day", true, setError);
      isValid = false;
    } else {
      handleValidationChange("sticks_per_day", false, setError);
    }
  } else {
    handleValidationChange("duration", false, setError);
    handleValidationChange("sticks_per_day", false, setError);
  }

  return isValid;
};

export const validateDrinking = (data, setError) => {
  /** Required:
   * is_drinker
   * frequency / consumption when is_drinker === "Y"
   */

  var isValid = true;

  if (!data.is_drinker) {
    handleValidationChange("is_drinker", true, setError);
    isValid = false;
  } else {
    handleValidationChange("is_drinker", false, setError);
  }

  if (data.is_drinker === "Y") {
    if (data.frequency === "" || data.frequency == null) {
      handleValidationChange("frequency", true, setError);
      isValid = false;
    } else {
      handleValidationChange("frequency", false, setError);
    }

    if (data.consumption === "" || data.consumption == null) {
      handleValidationChange("consumption", true, setError);
      isValid = false;
    } else {
      handleValidationChange("consumption", false, setError);
    }
  } else {
    handleValidationChange("frequency", false, setError);
    handleValidationChange("consumption", false, setError);
  }

  return isValid;
};

export const validateDrug = (data, setError) => {
  /** Required:
   * is_drug_user
   * name / last_intake when is_drug_user === "Y"
   */

  var isValid = true;

  if (!data.is_drug_user) {
    handleValidationChange("is_drug_user", true, setError);
    isValid = false;
  } else {
    handleValidationChange("is_drug_user", false, setError);
  }

  if (data.is_drug_user === "Y") {
    if (data.name === "" || data.name == null) {
      handleValidationChange("name", true, setError);
      isValid = false;
    } else {
      handleValidationChange("name", false, setError);
    }

    if (data.last_intake === "" || data.last_intake == null) {
      handleValidationChange("last_intake", true, setError);
      isValid = false;
    } else {
      handleValidationChange("last_intake", false, setError);
    }
  } else {
    handleValidationChange("name", false, setError);
    handleValidationChange("last_intake", false, setError);
  }

  return isValid;
};

export const validateHeredoFamilial = (data, setError) => {
  /** Required:
   * username
   * password
   */

  var isValid = true;

  if (data.name === "") {
    handleValidationChange("name", true, setError);
    isValid = false;
  } else {
    handleValidationChange("name", false, setError);
  }

  if (data.other === "") {
    handleValidationChange("other", true, setError);
    isValid = false;
  } else {
    handleValidationChange("other", false, setError);
  }

  return isValid;
};

export const validateVaxProfile = (data, setError) => {
  var isValid = true;

  if (data.vax_shot_id === "") {
    handleValidationChange("vax_shot_id", true, setError);
    isValid = false;
  } else {
    handleValidationChange("vax_shot_id", false, setError);
  }

  if (data.taken_on === "") {
    handleValidationChange("taken_on", true, setError);
    isValid = false;
  } else {
    handleValidationChange("taken_on", false, setError);
  }

  // if (data.next_shot_on === "") {
  //   handleValidationChange("next_shot_on", true, setError);
  //   isValid = false;
  // } else {
  //   handleValidationChange("next_shot_on", false, setError);
  // }

  return isValid;
};

export const validateCancerProfile = (data, setError) => {
  var isValid = true;

  if (data.organ === "") {
    handleValidationChange("organ", true, setError);
    isValid = false;
  } else {
    handleValidationChange("organ", false, setError);
  }

  // if (data.next_shot_on === "") {
  //   handleValidationChange("next_shot_on", true, setError);
  //   isValid = false;
  // } else {
  //   handleValidationChange("next_shot_on", false, setError);
  // }

  return isValid;
};

export const validateHepatitisProfile = (data, setError) => {
  var isValid = true;

  if (data.type === "") {
    handleValidationChange("type", true, setError);
    isValid = false;
  } else {
    handleValidationChange("type", false, setError);
  }

  // if (data.next_shot_on === "") {
  //   handleValidationChange("next_shot_on", true, setError);
  //   isValid = false;
  // } else {
  //   handleValidationChange("next_shot_on", false, setError);
  // }

  return isValid;
};

export const validateTBProfile = (data, setError) => {
  var isValid = true;

  if (data.category === "") {
    handleValidationChange("category", true, setError);
    isValid = false;
  } else {
    handleValidationChange("category", false, setError);
  }

  // if (data.next_shot_on === "") {
  //   handleValidationChange("next_shot_on", true, setError);
  //   isValid = false;
  // } else {
  //   handleValidationChange("next_shot_on", false, setError);
  // }

  return isValid;
};
